module.exports = __webpack_public_path__ + "img/category-item.81bda494.svg";